export const GET_PIN = 'PIN/get_pin';
export const GET_SINGLE_PIN = 'PIN/get_single_pin';
export const CREATE_PIN = 'PIN/create_pin';
export const UPDATE_PIN = 'PIN/update_pin';

export const FORM_DATA = {
  city_municipal: '',
  district: '',
};
